import * as React from "react";
import type { SVGProps } from "react";
const SvgCarFront = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6 15h1a1 1 0 0 0 0-2H6a1 1 0 0 0 0 2ZM18 15h-1a1 1 0 0 1 0-2h1a1 1 0 0 1 0 2ZM9.76 15.97a9.414 9.414 0 0 0 2.24.28 9.414 9.414 0 0 0 2.24-.28 1 1 0 0 0-.48-1.94 7.23 7.23 0 0 1-3.52 0 1 1 0 0 0-.48 1.94Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.98 19h-6v.49A1.52 1.52 0 0 1 7.49 21h-2a1.52 1.52 0 0 1-1.51-1.51V19a1 1 0 0 1-.87-.55l-.79-1.58A3 3 0 0 1 2 15.53v-3.06a3 3 0 0 1 .32-1.34l.563-1.134L2.385 9H1a1 1 0 0 1 0-2h2a1 1 0 0 1 .808.411L4.37 5.73A4 4 0 0 1 8.16 3h7.68a4 4 0 0 1 3.79 2.74l.56 1.673A.995.995 0 0 1 21 7h2a1 1 0 0 1 0 2h-1.385l-.498.996.563 1.134a3 3 0 0 1 .32 1.34v3.06a3 3 0 0 1-.32 1.34l-.79 1.58A1 1 0 0 1 20 19h-.02v.49A1.52 1.52 0 0 1 18.49 21h-2a1.52 1.52 0 0 1-1.51-1.51V19Zm4.4-2 .51-1a1 1 0 0 0 .11-.45v-3.06a.999.999 0 0 0-.11-.45l-.416-.837A28.352 28.352 0 0 1 12.12 12H12a29.72 29.72 0 0 1-7.472-.801l-.418.841a1 1 0 0 0-.11.45v3.06a1 1 0 0 0 .11.45l.51 1h14.76Zm-7.27-6.94c2.226.037 4.445-.21 6.606-.731L17.73 6.34a2 2 0 0 0-1.89-1.37H8.16a2 2 0 0 0-1.89 1.37l-.984 2.983c2.198.519 4.453.767 6.714.737h.11Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCarFront;
